import { defineComponent as o, openBlock as t, createElementBlock as r, normalizeClass as s, normalizeStyle as n, Fragment as d, renderList as m, withDirectives as c, createBlock as u, unref as f, renderSlot as v } from "vue";
import y from "./IstItem.vue.mjs";
import p from "../../node_modules/v-wave/dist/es/index.mjs";
const S = /* @__PURE__ */ o({
  __name: "IstList",
  props: {
    /**
     * The class applied to the component when it is in an active state.
     */
    activeClass: {
      type: String,
      default: void 0
    },
    bgColor: {
      type: String,
      default: void 0
    },
    /**
     * Adjusts the vertical height used by the component. Accepts the following values: 'default', 'comfortable', 'compact'
     */
    density: {
      type: String,
      default: "default",
      validator: (e) => ["default", "comfortable", "compact"].includes(e)
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const a = p;
    return (l, g) => (t(), r("div", {
      class: s([(e.activeClass, e.density), "ist-list--bordered ist-list--separator"]),
      style: n({ backgroundColor: e.bgColor })
    }, [
      (t(!0), r(d, null, m(e.items, (i) => c((t(), u(y, {
        key: i.id,
        item: "item"
      })), [
        [f(a)]
      ])), 128)),
      v(l.$slots, "default", {}, void 0, !0)
    ], 6));
  }
});
export {
  S as default
};
